import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default ({ typography, breakpoints }: Theme) =>
  createStyles({
    topContent: {
      margin: '10px 0',
    },

    buttonAvatar: {
      display: 'block',
      padding: 5,
      borderRadius: 4,
      border: `1px solid ${palette.gray}`,
      margin: '0 auto 24px',
      '&:disabled': {
        opacity: 0.7,
      },
    },
    hiddenIcon: {
      display: 'none',
    },
    avatar: {
      width: 182,
      height: 182,
      background: palette.gray,
      fontSize: 40,
      fontWeight: typography.fontWeightMedium,
      letterSpacing: 3,
    },
    editIcon: {
      position: 'absolute',
      right: 13,
      bottom: 13,
      color: palette.white,
    },

    textName: {
      fontSize: 20,
    },
    textRole: {
      fontWeight: typography.fontWeightMedium,
    },

    switchChecked: {
      '&.Mui-checked': {
        color: palette.green,

        '& + .MuiSwitch-track': {
          backgroundColor: palette.green,
        },
      },
    },
    switchLabel: {
      fontSize: 14,
    },

    buttons: {
      margin: '40px auto',

      '& .MuiButtonBase-root': {
        fontFamily: 'Roboto',
        minWidth: 112,
        padding: 8,
        margin: '0 8px',
        fontSize: 14,
        fontWeight: typography.fontWeightMedium,
        borderRadius: 4,
      },
    },
    buttonsModal: {
      margin: 0,

      '& .MuiButtonBase-root': {
        fontFamily: 'Roboto',
        minWidth: 112,
        padding: 8,
        margin: '0 8px',
        fontSize: 14,
        fontWeight: typography.fontWeightMedium,
        borderRadius: 4,
      },
    },
    buttonCancel: {
      border: `1px solid ${palette.gray}`,
      color: palette.gray,
    },
    formsGrid: {
      boxShadow: `0 1px 1px 0 ${palette.mediumShadow}, 0 2px 1px -1px ${palette.lightShadow}, 0 1px 3px 0 ${palette.darkShadow}`,
      borderRadius: 10,
      padding: 10,
      justifyContent: 'flex-start',
    },
    formsGridModal: {
      borderRadius: 10,
      padding: 10,
      justifyContent: 'flex-start',
    },
    formContainer: {
      width: '100%',
      '& .MuiGrid-container': {
        alignItems: 'center',
      },
    },
    selectCompanyGrid: {
      padding: 8,
      [breakpoints.up('lg')]: {
        width: '31.7%',
      },
      [breakpoints.down('md')]: {
        width: '30.5%',
      },
      [breakpoints.down('xs')]: {
        width: '29%',
      },
    },
    resetButton: { margin: '0 !important', alignItems: 'center' },
    resetButtonText: { fontSize: 12, color: palette.blue },
    listRestrictions: {
      listStyle: 'none',
      padding: 0,
      margin: '0 0 24px 8px',

      '& li': {
        marginBottom: 5,
        fontFamily: 'Roboto',
        fontSize: 12,
        color: palette.gray,

        '&:before': {
          content: '"•"',
          marginRight: 5,
        },

        '&.valid': {
          color: palette.passwordBlue,

          '&:before': {
            content: '"✓"',
          },
        },
      },
    },
    passwordRules: { fontSize: 14, margin: '0px 0px 5px 8px' },
    divider: {
      width: '100%',
      margin: '0 0 10px',
      height: 0,
    },
    historyContainer: {
      marginTop: 15,
    },
    creationInfo: {
      padding: '0 4px 0px 9px',
      justifyContent: 'flex-end',
    },
    buttonsInfo: {
      padding: '0 4px 0px 9px',
      justifyContent: 'flex-end',
    },
    creationText: {
      fontSize: 12,
      color: palette.darkGray,
    },
    forgotPasswordLinkText: {
      fontSize: 12,
      fontWeight: 500,
    },
    spacingText: {
      padding: '0 5px',
      fontSize: 14,
    },
    upperButton: {
      '& .MuiButton-outlined': {
        margin: '10px !important',
        padding: '2px 5px !important',
      },
    },
    buttonGreen: {
      border: `0.7px solid ${palette.green}`,
      color: palette.green,
      boxShadow: `0 1px 1px 0 ${palette.mediumShadow}, 0 2px 1px -1px ${palette.lightShadow}, 0 1px 3px 0 ${palette.darkShadow}`,
    },
    buttonRed: {
      border: `0.7px solid ${palette.red}`,
      boxShadow: `0 1px 1px 0 ${palette.mediumShadow}, 0 2px 1px -1px ${palette.lightShadow}, 0 1px 3px 0 ${palette.darkShadow}`,
    },
    buttonBlue: {
      border: `0.7px solid ${palette.blue}`,
      boxShadow: `0 1px 1px 0 ${palette.mediumShadow}, 0 2px 1px -1px ${palette.lightShadow}, 0 1px 3px 0 ${palette.darkShadow}`,
    },
    buttonTextRed: {
      fontWeight: 400,
      fontSize: 12,
      color: palette.red,
    },
    buttonTextGreen: {
      fontWeight: 400,
      fontSize: 12,
      color: palette.green,
    },
    resetText: { fontWeight: 400, fontSize: 12, color: palette.blue },
    checkIcon: {
      fontSize: 12,
      color: palette.green,
      margin: '0 2px 0 0',
      '& .MuiSvgIcon-root': {
        width: 15,
        height: 15,
      },
    },
    blockIcon: {
      fontSize: 12,
      color: palette.red,
      margin: '0 2px 0 0',
      '& .MuiSvgIcon-root': {
        width: 15,
        height: 15,
      },
    },
    blueIcon: {
      fontSize: 12,
      color: palette.blue,
      margin: '0 2px 0 0',
      '& .MuiSvgIcon-root': {
        width: 15,
        height: 15,
      },
    },
    resetPassword: {
      backgroundColor: palette.blue,
      color: palette.white,
      fontSize: '12px !important',
      padding: '6px !important',
      height: '30px !important',
      '&:hover': { backgroundColor: palette.blue, color: palette.white },
    },
    header: {
      alignItems: 'center',
      paddingBottom: 10,
      display: 'flex',
      marginBottom: 10,
    },
    titles: {
      fontSize: 14,
      fontWeight: 500,
      fontFamily: 'Roboto',
    },
    table: {
      boxSizing: 'border-box',
      marginBottom: 20,
      overflowX: 'auto',
      maxHeight: 450,
    },
    tableTitle: {
      fontSize: 12,
      paddingBottom: 5,
      fontWeight: 500,
      marginLeft: 8,
      paddingTop: 4,
    },
    titleBackground: {
      backgroundColor: palette.lightGray,
    },
    text: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',

      '& .MuiTypography-root': {
        fontSize: 12,
      },
    },
    centerFields: {
      textAlign: 'center',
      fontSize: 12,

      '& .MuiIconButton-root': {
        padding: 0,
      },
    },
    accessButtonHeader: {
      width: 40,
      fontSize: 12,
      color: palette.darkGray,
    },
    linkGroup: {
      cursor: 'pointer',
      color: palette.navSuperAdmin,
      textDecoration: 'underline',
      alignItems: 'center',
      display: 'flex',
    },
    accessButton: {
      fontSize: 15,
      color: palette.blue,
      cursor: 'pointer',
    },
    notFoundText: {
      fontSize: 12,
    },
    checkboxCell: {
      padding: '0px 8px !important',

      '& .MuiCheckbox-root': {
        padding: 0,
      },

      '& span > span > svg': { width: 15, height: 15 },
    },
    buttonManagePermissions: {
      backgroundColor: palette.white,
      height: 45,
      color: palette.blue,
      border: `0.7px solid ${palette.blue}`,
      boxShadow: `0 1px 1px 0 ${palette.mediumShadow}, 0 2px 1px -1px ${palette.lightShadow}, 0 1px 3px 0 ${palette.darkShadow}`,
    },
    buttonManagePermissionsText: { color: palette.blue },
    status: {
      gap: '8px',
      '& .MuiTypography-root': {
        fontSize: 12,
      },
    },

    searchButton: {
      alignItems: 'center',
      justifyContent: 'flex-end',
      display: 'flex',
      width: '15%',
      [breakpoints.down('md')]: {
        width: '20%',
      },
      [breakpoints.down('xs')]: {
        width: '100%',
        justifyContent: 'center',
      },

      '& .MuiTypography-root': {
        fontSize: 12,
      },
    },
    titleGrid: {
      margin: 8,
      padding: 8,
      border: `1px solid ${palette.lightGray}`,
      borderRadius: 8,
    },
    titleGridError: {
      border: `1px solid ${palette.red}`,
    },
    boldText: {
      fontWeight: 'bold',
      fontSize: 12,
    },
    searchButtonSize: { margin: '0px 8px 0px 0px' },
    buttonIsLoading: { backgroundColor: palette.borderGray },
  });
